import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import login from '@/views/login/login.vue'
import AdminMain from '@/views/admin/admin-main.vue'
import NotFound from '@/views/error/404.vue'
import localCache from '@/utils/cache'
import store from '@/store'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminMain,
    children: [
      {
        path: 'info/owner/add',
        name: 'OwnerAdd',
        component: () => import('@/views/admin/info/owner/owner-form.vue'),
        meta: { title: '新增业主' }
      },
      {
        path: 'info/owner/edit',
        name: 'OwnerEdit',
        component: () => import('@/views/admin/info/owner/owner-form.vue'),
        meta: { title: '编辑业主' }
      }
    ]
  },
  {
    path: '/login',
    name: '登录',
    component: login
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: NotFound
  }
]

const router = createRouter({
  routes,
  history: createWebHistory()
})

router.beforeEach((to) => {
  if (to.path.startsWith('/admin')) {
    const token = localCache.getCache('token')
    if (!token) {
      return '/login'
    }
  }

  if (to.path === '/admin') {
    const firstMenu = store.getters['firstMenu']
    return firstMenu?.path
  }
})

export default router
